<script lang="ts">
    import IndefiniteSpinnerIcon from '@amp/web-app-components/assets/icons/indefinite-spinner.svg';

    export let duration: number = 1;
</script>

<div
    data-testid="spinner"
    class="spinner"
    style="--spinner-duration: {duration}"
>
    <IndefiniteSpinnerIcon />
</div>

<style lang="scss">
    .spinner {
        height: 100%;
        width: 25px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        fill: var(--spinnerFillColor, var(--keyColor));
        animation: spin calc(var(--spinner-duration, 1) * 1s) linear infinite;
        margin-inline-end: 10px;

        :global(svg path) {
            animation: addToSpinner calc(var(--spinner-duration, 1) * 1s) linear
                infinite;
            transform-origin: center center;
        }
    }

    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes addToSpinner {
        100% {
            transform: rotate(360deg);
        }
    }
</style>
